export enum PensionProductCode {
  ike = 'IKE',
  ikze = 'IKZE',
}

export enum ProductCode {
  basic = 'BASIC',
  ike = 'IKE',
  ikze = 'IKZE',
  ppe = 'PPE',
  ppk = 'PPK',
  ppi = 'PPI',
}
